import Tag from '@decisiv/ui-components/lib/components/Tag';
import { Container } from './styles';

type Props = {
  rowData: Pick<SentinelTeam, 'scheduledForDeletionAt'> & {
    platformAccounts: Pick<
      SentinelTeam['platformAccounts'][0],
      'id' | 'sourceId'
    >[];
  };
};

export default function PlatformAccountsCell({
  rowData: { platformAccounts, scheduledForDeletionAt },
}: Props) {
  const scheduledForDeletionProps = {
    ...(scheduledForDeletionAt && {
      palette: 'pastel',
      color: 'licoriceMousse',
      variant: undefined,
    }),
  };

  return (
    <Container>
      {platformAccounts.map((platformAccount) => (
        <Tag
          key={platformAccount.id}
          size="small"
          variant="outline"
          text={platformAccount.sourceId}
          {...scheduledForDeletionProps}
        />
      ))}
    </Container>
  );
}
// color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
